import React from 'react'
import { Box } from "@chakra-ui/react"
import FooterOptions from './FooterOptions'
import "./Footer.module.css"
function Footer() {
    return (
        <Box >
            <FooterOptions />
        </Box>
    )
}

export default Footer